import type { IconNode } from '../types';

/**
 * @name astronaut-helmet
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAuNiAxMy40IDYuMyA2LjFjLjMuNS4xIDEuMS0uNCAxLjQtMS40LjctMi45IDEuMS00LjUgMS4xYTIgMiAwIDAgMS0xLjQtLjZsLTgtOEEyIDIgMCAwIDEgMiAxMmExMCAxMCAwIDAgMSAxOS40NC0zLjNjLjMuNy0uMyAxLjMtMSAxLjNIMTIiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTYuMiAxOC44YzMtMS45IDQuNC01LjUgMy41LTguOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/astronaut-helmet
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const astronautHelmet: IconNode = [
  [
    'path',
    {
      d: 'm10.6 13.4 6.3 6.1c.3.5.1 1.1-.4 1.4-1.4.7-2.9 1.1-4.5 1.1a2 2 0 0 1-1.4-.6l-8-8A2 2 0 0 1 2 12a10 10 0 0 1 19.44-3.3c.3.7-.3 1.3-1 1.3H12',
      key: '1vcm40',
    },
  ],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['path', { d: 'M16.2 18.8c3-1.9 4.4-5.5 3.5-8.8', key: 'twsywe' }],
];

export default astronautHelmet;
